import vue from '@/main'

export default {
  error ({msg, timeout = 5000, position = 'toast-top-right', title = vue.$messages.TITULO_ERROR}) {
    vue.$toastr(vue.$messages.TIPO_ERROR,
      {
        title,
        msg,
        clickClose: true,
        timeout,
        position
      }
    )
  },
  warning ({msg, timeout = 5000, position = 'toast-top-right', title = vue.$messages.TITULO_WARNING}) {
    vue.$toastr(vue.$messages.TIPO_WARNING,
      {
        title,
        msg,
        clickClose: true,
        timeout: msg.length > 60 ? 7000 : timeout,
        position
      }
    )
  },
  confirmBox({body, confirmButtonText = 'Confirmar', cancelButtonText = 'Cancelar', type = 'warning'}) { // eslint-disable-line
    window.setTimeout(() => {
      vue.$confirm(body.message, body.title, {
        confirmButtonText,
        cancelButtonText,
        type
      })
        .then(body.callback)
        .catch(body.error)
    }, 100)
  }
}



// WEBPACK FOOTER //
// ./src/utils/alert.js